<!--content-->
<div class="admin">
  <div class="container">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
          <!-- <li>
            <a>
              Solicitar
            </a>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h2 class="txt txt--title">Ampliar licencia</h2>
        <small>Podrás ampliar los documentos asociados a la licencia.</small>
      </div>
      <div class="admin__actions col-12">
        <div class="row">
          <div class="col-12 col-lg-4" *ngIf="showThirdPersonRequest">
            <div class="admin__action" routerLink="./third/select">
              <h3>Ampliar licencia para un empleado o contratista*</h3>
            </div>
            <small class="note note--mobile">*Solo se puede solicitar para un empleado o contratista del mismo contrato
              o área.</small>
          </div>
          <div class="col-12 col-lg-4" *ngIf="showPersonalRequest">
            <div class="admin__action" routerLink="./select-license" routerLinkActive="true">
              <h3>Ampliar mi licencia</h3>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="showThirdPersonRequest">
          <p class="note note--desktop">*Solo se puede solicitar para un empleado o contratista del mismo contrato o
            área.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<!--content-->
